import { DefaultTheme } from "styled-components";

export const reviewsConfig = [
  {
    interval: { min: 87, max: 100 },
    name: "excellent",
    translation: "Ausgezeichnet",
    colorKey: "success" as const,
    colorShade: "600" as const,
  },
  {
    interval: { min: 81, max: 86 },
    name: "verygood",
    translation: "Sehr Gut",
    colorKey: "success" as const,
    colorShade: "500" as const,
  },
  {
    interval: { min: 75, max: 80 },
    name: "good",
    translation: "Gut",
    colorKey: "success" as const,
    colorShade: "400" as const,
  },
  {
    interval: { min: 60, max: 74 },
    name: "fair",
    translation: "Zufriedenstellend",
    colorKey: "success" as const,
    colorShade: "200" as const,
  },
  {
    interval: { min: 0, max: 59 },
    name: "poor",
    translation: "Schlecht",
    colorKey: "warning" as const,
    colorShade: "400" as const,
  },
];

export function getConfigByPercentage(percentage: number) {
  return (
    reviewsConfig.find(
      (config) =>
        percentage >= config.interval.min && percentage <= config.interval.max
    ) || reviewsConfig[reviewsConfig.length - 1]
  );
}

export function getColorByPercentage(
  percentage: number,
  theme: DefaultTheme
): string {
  const config = getConfigByPercentage(Math.round(percentage));
  return theme.kallisto.color.common.semantic[config.colorKey][
    config.colorShade
  ];
}

export function getLabelByPercentage(percentage: number): string {
  return getConfigByPercentage(Math.round(percentage)).translation;
}
